import React from 'react'
import Footer from '../global/Footer'
import NavBar from '../global/NavBar'
import Launchpad from '../Launchpad/Launchpad'

const Home = () => {
  return (
    <>
      <Launchpad />
      <Footer />
    </>
  )
}

export default Home